import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Alert from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Alert';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';
import Actions from '../../../Components/Actions';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  agreeButton: {
    margin: theme.spacing(2, 0),
  },
});

const WebsiteAgreementActions = ({
  className,
  classes,
  isPrimaryClient,
  savingResponseError,
  onAgree,
  isSavingResponse,
  navigateToDeclined,
}) => {
  return (
    <Actions
      className={classNames(classes.root, className)}
    >
      {savingResponseError && (
        <Alert variant="filled" severity="error">
          <Typography
            variant={'h5'}
            weight={'bold'}
            color={'inherit'}
          >
            {'There was an issue agreeing to our Website Access & Electronic Delivery Acknowledgement'}
          </Typography>
        </Alert>)
      }
      {isPrimaryClient
        ? (
          <React.Fragment>
            <RoundedButton
              className={classes.agreeButton}
              onClick={onAgree}
              color={'primary'}
              variant={'contained'}
              isLoading={isSavingResponse}
              disableElevation
              size={DS_SIZE_MAP.sm}
              test={'website-agreement-accept-button'}
              fullWidth
            >
              {'Agree to Website Agreement'}
            </RoundedButton>
            <TextButton
              disabled={isSavingResponse}
              onClick={navigateToDeclined}
              color={'primaryGray'}
              weight={'bold'}
              size={DS_SIZE_MAP.sm}
              fullWidth
              test={'website-agreement-decline-button'}
            >
              {'Decline Website Agreement'}
            </TextButton>
          </React.Fragment>)
        : null
      }
    </Actions>
  );
};

WebsiteAgreementActions.defaultProps = {
  className: '',
  savingResponseError: null,
};

WebsiteAgreementActions.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  isPrimaryClient: PropTypes.bool.isRequired,
  isSavingResponse: PropTypes.bool.isRequired,
  savingResponseError: PropTypes.object,
  onAgree: PropTypes.func.isRequired,
  navigateToDeclined: PropTypes.func.isRequired,
};

export default withStyles(styles)(WebsiteAgreementActions);
